(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-last"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const selector = 'button[type="submit"][name="checkout"], #checkout';

  function upgradeCheckoutButton(btn) {
    if (!btn || btn.dataset.enhanced === "true") return;
    btn.dataset.enhanced = "true";

    let spinner = btn.querySelector('.checkout-spinner');

    btn.addEventListener('click', () => {
      // Don't double-trigger
      if (btn.classList.contains('cart__checkout-button--disabled')) return;

      // Show spinner AFTER click, but DO NOT block form submit
      btn.classList.add('cart__checkout-button--disabled');
      btn.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.classList.remove('hidden');

      // IMPORTANT: Let Shopify submit the form normally!!
      // No preventDefault, no stopPropagation.
      // Do NOT override drawer close methods.
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach(upgradeCheckoutButton);
  }

  // Initial attach
  init();

  // Shopify re-renders the drawer → re-bind
  const observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });

  // Warn: Safari back/forward cache restores disabled state — fix it
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      const btn = document.querySelector(selector);
      if (!btn) return;
      btn.classList.remove("cart__checkout-button--disabled");
      btn.removeAttribute("aria-disabled");
      let spinner = btn.querySelector(".checkout-spinner");
      if (spinner) spinner.classList.add("hidden");
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /* Checkout spinner support */

document.addEventListener('DOMContentLoaded', () => {

const selector = 'button[type="submit"][name="checkout"], #checkout';

function upgradeCheckoutButton(btn){

if(!btn || btn.dataset.enhanced==="true") return;

btn.dataset.enhanced="true";

btn.addEventListener('click',()=>{

btn.classList.add('cart__checkout-button--disabled');

btn.setAttribute('aria-disabled','true');

});

}

function init(){
document.querySelectorAll(selector).forEach(upgradeCheckoutButton);
}

init();

new MutationObserver(init).observe(document.body,{
childList:true,
subtree:true
});

});
  } catch(e) { console.error(e); }
})();

})();
